import GeneralHead from "@logics/tags/GeneralHead";
import { loadPropsWithLocale } from "@logics/utils/i18n";
import Carrot from "@domains/landing/views/Carrot/Carrot";
import StackLayout from "@domains/common/views/layouts/StackLayout/StackLayout";

const CarrotLandingPage = () => {
  return (
    <>
      <GeneralHead />

      <StackLayout hideNavbar>
        <Carrot />
      </StackLayout>
    </>
  );
};

export default CarrotLandingPage;

export const getStaticProps = loadPropsWithLocale();
